import { render, staticRenderFns } from "./donut.vue?vue&type=template&id=386a94da"
import script from "./donut.vue?vue&type=script&lang=js"
export * from "./donut.vue?vue&type=script&lang=js"
import style0 from "./donut.vue?vue&type=style&index=0&id=386a94da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports